import { Injector, PLATFORM_ID } from '@angular/core';
import { LocalFacade, LocalState } from '@common/localstate/frontend-shared';
import { AccessState, AppRequestService } from '@core/frontend-shared';
import { ConfigService } from '@core/shared/config';
import { UpdateTrackingConsentRequest } from '@common/tracking/shared';
import { Store } from '@ngxs/store';
import { Angulartics2, Angulartics2Matomo } from 'angulartics2';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MatomoInjector } from '../matomo-injector.service';
import { isPlatformBrowser } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@common/localstate/frontend-shared";
import * as i2 from "@ngxs/store";
import * as i3 from "@core/shared/config";
import * as i4 from "@core/frontend-shared";
const LOCALSTATE_TRACKING_ID = 'tracking-consent';
/**
 * currently managed by tracking-consent component which must be in app component / always included, only then tracking will work
 */
export let TrackingService = /*#__PURE__*/(() => {
  class TrackingService {
    constructor(localSettings, store, config, injector, api, platformId) {
      this.localSettings = localSettings;
      this.store = store;
      this.config = config;
      this.injector = injector;
      this.api = api;
      this.platformId = platformId;
      this.consentState = new BehaviorSubject(null);
      this.trackingEnabled = false;
      if (isPlatformBrowser(this.platformId)) {
        const savedConsent = this.store.selectSnapshot(LocalState.get(LOCALSTATE_TRACKING_ID, null));
        this.consentState.next(savedConsent);
        this.consentState.pipe(filter(val => typeof val === 'boolean')).subscribe(consent => {
          if (consent) {
            this.trackingEnabled = true;
            this.startTracking();
          } else {
            if (this.trackingEnabled) {
              // cannot stop tracking in code, need to do page reload
              window.location.reload();
            }
          }
        });
      }
    }
    saveConsentPreference(consent) {
      this.api.sendRequest(UpdateTrackingConsentRequest, {
        consent
      }).subscribe();
      this.consentState.next(consent);
      this.localSettings.set(LOCALSTATE_TRACKING_ID, consent);
    }
    unsetConsentPreference() {
      this.consentState.next(null);
      this.localSettings.set(LOCALSTATE_TRACKING_ID, null);
    }
    startTracking() {
      const matomoUrl = this.config.get('tracking.matomoUrl');
      const matomoSiteId = this.config.get('tracking.matomoSiteId');
      if (!matomoUrl) return;
      const matomoInj = this.injector.get(MatomoInjector);
      const matomoService = this.injector.get(Angulartics2Matomo);
      matomoInj.init(matomoUrl, matomoSiteId);
      matomoService.startTracking();
      const angulartics = this.injector.get(Angulartics2);
      this.store.select(AccessState.sessionId).subscribe(sessionId => {
        if (sessionId) {
          angulartics.setUsername.next(sessionId.substring(0, 10));
        } else {
          angulartics.setUsername.next(null);
        }
      });
    }
    static {
      this.ɵfac = function TrackingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackingService)(i0.ɵɵinject(i1.LocalFacade), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i3.ConfigService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i4.AppRequestService), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: TrackingService,
        factory: TrackingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TrackingService;
})();